// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConditionRule
 */
export interface ConditionRule {
  /**
   *
   * @type {Array<string>}
   * @memberof ConditionRule
   */
  allOf?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ConditionRule
   */
  type?: string;
}

/**
 * Check if a given object implements the ConditionRule interface.
 */
export function instanceOfConditionRule(value: object): value is ConditionRule {
  return true;
}

export function ConditionRuleFromJSON(json: any): ConditionRule {
  return ConditionRuleFromJSONTyped(json, false);
}

export function ConditionRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConditionRule {
  if (json == null) {
    return json;
  }
  return {
    allOf: json['all_of'] == null ? undefined : json['all_of'],
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function ConditionRuleToJSON(json: any): ConditionRule {
  return ConditionRuleToJSONTyped(json, false);
}

export function ConditionRuleToJSONTyped(
  value?: ConditionRule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    all_of: value['allOf'],
    type: value['type'],
  };
}
